import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { MailAttachmentEntity } from './mail-attachment.entity';
import { MailRecipientEntity } from './mail-recipient.entity';
import { MailSourceEntity } from './mail-source.entity';
import { MailUserStatusEntity } from './mail-user-status.entity';

@Index('_fk__mail_source__id', ['fkMailSourceId'], {})
@Index('_in_reply_to_ix', ['inReplyTo'], {})
@Index('_message_id_ix', ['messageId'], {})
@Index('_unique_mail_record', ['externalRecordId'], { unique: true })
@Entity('_mail_record')
export class MailRecordEntity extends BaseEntity {
	@Column('int', {
		name: '_fk__mail_source__id',
		nullable: true,
		unsigned: true,
	})
	public fkMailSourceId!: number | null;

	@Column('varchar', {
		name: '_externalRecordId',
		nullable: true,
		unique: true,
		length: 191,
	})
	public externalRecordId!: string | null;

	@Column('varchar', { name: '_subject', length: 255 })
	public subject!: string;

	@Column('longtext', { name: '_content' })
	public content!: string;

	@Column('varchar', { name: '_type', length: 150 })
	public type!: string;

	@Column('varchar', { name: '_messageId', length: 191 })
	public messageId!: string;

	@Column('varchar', { name: '_inReplyTo', nullable: true, length: 191 })
	public inReplyTo!: string | null;

	@OneToMany(
		() => MailAttachmentEntity,
		(mailAttachment) => mailAttachment.fkMailRecord,
		{},
	)
	public mailAttachments!: Array<MailAttachmentEntity>;

	@OneToMany(
		() => MailRecipientEntity,
		(mailRecipient) => mailRecipient.fkMailRecord,
		{},
	)
	public mailRecipients!: Array<MailRecipientEntity>;

	@ManyToOne(() => MailSourceEntity, (mailSource) => mailSource.mailRecords, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__mail_source__id', referencedColumnName: 'id' }])
	public fkMailSource!: MailSourceEntity;

	@OneToMany(
		() => MailUserStatusEntity,
		(mailUserStatus) => mailUserStatus.fkMailRecord,
		{},
	)
	public mailUserStatuses!: Array<MailUserStatusEntity>;
}
